exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media(max-width:1299px){.news-card__col[data-v-3a2e4334]{padding:0 5px}}@media(max-width:1023px)and (min-width:768px){.news-card__col[data-v-3a2e4334]{width:50%}.news-card__col .news-card__item[data-v-3a2e4334]{margin-left:auto;margin-right:auto}}", ""]);

// exports
